/* eslint-disable jsx-a11y/control-has-associated-label */
/* eslint-disable react/no-array-index-key */
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable react/prop-types */
/* eslint-disable no-bitwise */
/* eslint-disable no-nested-ternary */
/* eslint-disable max-len */
/* eslint-disable object-curly-newline */
/* eslint-disable import/no-unresolved */
/* eslint-disable no-unused-vars */
import React, { useContext, useEffect, useMemo, useState } from 'react';
import moment from 'moment-timezone';
import { format, startOfMonth, endOfMonth } from 'date-fns';
// eslint-disable-next-line import/no-extraneous-dependencies
import {
  Bell,
  Clock,
  CheckCircle,
  TrendingUp,
  Info,
  ArrowUpRight,
  ArrowDownRight,
  Users,
  UserCog,
  ChevronRight,
  ChevronLeft,
  ChevronDown,
  Search,
  ChevronsUpDown,
  ChevronUp,
  Calendar,
} from 'lucide-react';
// eslint-disable-next-line import/no-extraneous-dependencies
import { motion } from 'motion/react';
import './index.css';
import { sendRequest } from '../../api/shootAPI';
import API from '../../api/endpoints';
import { UserContext } from '../../contexts/User';
import {
  countWeekdaysInRange,
  currentMonthWeekRange,
  getDatesInRange,
  convertSecToTimeFormat,
} from '../../utils/time';

const softShadow = 'shadow-[0_1px_2px_rgba(14,30,64,0.04)]';

function lastNDays(n) {
  const to = new Date();
  to.setHours(0, 0, 0, 0);
  const from = new Date(to);
  from.setDate(from.getDate() - (n - 1));
  return { from, to };
}

// Static channel metadata only — alert items are loaded from the API.
const BOT_CHANNELS = [
  {
    id: 'hr', label: 'HR Bot Alerts', apiKey: 'HR', userColor: '#EE7C5C', accentEnd: 'oklch(0.6 0.2 15)',
  },
  {
    id: 'it', label: 'IT Bot Alerts', apiKey: 'IT', userColor: '#F19E41', accentEnd: 'oklch(0.62 0.18 55)',
  },
  {
    id: 'infosec', label: 'Infosec Bot Alerts', apiKey: 'Infosec', userColor: '#64BA62', accentEnd: 'oklch(0.55 0.15 165)',
  },
];

function InfoTooltip({ text, placement = 'top' }) {
  const below = placement === 'bottom';
  return (
    <span className="relative inline-flex items-center group">
      <Info size={12} className="text-[#a8afbc] cursor-help group-hover:text-brand-500 transition" />
      <span
        role="tooltip"
        className={`pointer-events-none absolute left-1/2 -translate-x-1/2 ${below ? 'top-full mt-1.5' : 'bottom-full mb-1.5'} z-50 w-56 px-3 py-2 rounded-md bg-ink-900 text-white text-[11px] leading-snug font-normal normal-case tracking-normal shadow-lg opacity-0 ${below ? 'translate-y-[-4px]' : 'translate-y-1'} group-hover:opacity-100 group-hover:translate-y-0 transition-all duration-150`}
      >
        {text}
        <span
          className={`absolute left-1/2 -translate-x-1/2 w-0 h-0 border-l-4 border-r-4 border-l-transparent border-r-transparent ${below ? 'bottom-full border-b-4 border-b-ink-900' : 'top-full border-t-4 border-t-ink-900'}`}
        />
      </span>
    </span>
  );
}

function Sparkline({ points, color }) {
  const max = Math.max(...points);
  const min = Math.min(...points);
  const range = max - min || 1;
  const w = 80;
  const h = 24;
  const step = w / (points.length - 1);
  const path = points
    .map((p, i) => `${i === 0 ? 'M' : 'L'} ${i * step} ${h - ((p - min) / range) * h}`)
    .join(' ');
  const area = `${path} L ${w} ${h} L 0 ${h} Z`;
  const id = `grad-${color.replace('#', '')}`;
  return (
    <svg width={w} height={h} className="overflow-visible">
      <defs>
        <linearGradient id={id} x1="0" x2="0" y1="0" y2="1">
          <stop offset="0%" stopColor={color} stopOpacity="0.25" />
          <stop offset="100%" stopColor={color} stopOpacity="0" />
        </linearGradient>
      </defs>
      <path d={area} fill={`url(#${id})`} />
      <path d={path} fill="none" strokeWidth="1.5" stroke={color} strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}

function RadialGauge({ value, color = '#5A81BC', label = 'Engagement' }) {
  const r = 52;
  const circ = Math.PI * r;
  const len = (value / 100) * circ;
  return (
    <div className="relative w-36 h-24">
      <svg viewBox="0 0 140 80" className="w-full h-full">
        <path
          d={`M 14 70 A ${r} ${r} 0 0 1 126 70`}
          fill="none"
          strokeWidth="10"
          className="stroke-surface-1"
          strokeLinecap="round"
        />
        <motion.path
          initial={{ strokeDasharray: `0 ${circ}` }}
          animate={{ strokeDasharray: `${len} ${circ}` }}
          transition={{ duration: 1, ease: 'easeOut' }}
          d={`M 14 70 A ${r} ${r} 0 0 1 126 70`}
          fill="none"
          strokeWidth="10"
          stroke={color}
          strokeLinecap="round"
        />
      </svg>
      <div className="absolute inset-0 flex flex-col items-center justify-end pb-1">
        <span className="text-3xl font-bold text-ink-900 leading-none">{`${value}%`}</span>
        <span className="text-[10px] text-ink-500 uppercase tracking-wider mt-0.5">{label}</span>
      </div>
    </div>
  );
}

function StackedBar({ segments }) {
  return (
    <div className="h-2 w-full bg-surface-1 rounded-full overflow-hidden flex">
      {segments.map((s, i) => (
        <motion.div
          key={i}
          initial={{ width: 0 }}
          animate={{ width: `${s.pct}%` }}
          transition={{ duration: 0.8, ease: 'easeOut' }}
          style={{ backgroundColor: s.color }}
        />
      ))}
    </div>
  );
}

const toMinutes = (t) => {
  const [h, m, s] = t.split(':').map(Number);
  return h * 3600 + m * 60 + (s || 0);
};

function activityPillBg(value) {
  if (value >= 50) return '#53A551';
  if (value >= 30) return '#F19235';
  return '#CC4525';
}

function ActivityPill({ value }) {
  return (
    <span
      className="inline-flex items-center justify-center px-2 py-0.5 rounded-md text-[11px] font-semibold text-white tabular-nums"
      style={{ backgroundColor: activityPillBg(value), minWidth: 40 }}
    >
      {`${value}%`}
    </span>
  );
}

function qualityPct(r) {
  const work = toMinutes(r.work);
  const quality = toMinutes(r.quality);
  return work > 0 ? Math.round((quality / work) * 100) : 0;
}

const AVATAR_PALETTE = [
  { bg: '#fdebe6', fg: '#b94f3c' },
  { bg: '#fde6d2', fg: '#F19235' },
  { bg: '#eef5ea', fg: '#53A551' },
  { bg: '#e8eef7', fg: '#4062E5' },
];

function avatarColors(name) {
  let h = 0;
  for (let i = 0; i < name.length; i += 1) {
    h = (h * 31 + name.charCodeAt(i)) >>> 0;
  }
  return AVATAR_PALETTE[h % AVATAR_PALETTE.length];
}

function ShiftCard({
  title, reason, timeline, items, metricColor,
}) {
  return (
    <div className={`rounded-xl bg-white border border-surface-2 ${softShadow} flex flex-col overflow-hidden`}>
      <div className="px-4 pt-4 pb-3 border-b border-surface-1">
        <h4 className="text-[11px] font-semibold text-ink-900 uppercase tracking-wider mb-2">{title}</h4>
        <div className="space-y-1">
          <div className="flex items-center gap-1.5 text-xs text-ink-500">
            <Clock size={12} className="flex-shrink-0" />
            <span>{reason}</span>
          </div>
          <div className="flex items-center gap-1.5 text-xs text-ink-500">
            <Bell size={12} className="flex-shrink-0" />
            <span>{timeline}</span>
          </div>
        </div>
      </div>
      <div className="px-4 py-3 space-y-2.5 max-h-[220px] overflow-y-auto">
        {items.length === 0 && (
          <div className="text-xs text-ink-500 py-4 text-center">No members in this range</div>
        )}
        {items.map((m) => {
          const c = avatarColors(m.name);
          return (
            <div key={m.name} className="flex items-center gap-3">
              <div
                className="w-7 h-7 rounded-full flex items-center justify-center text-[10px] font-semibold flex-shrink-0"
                style={{ backgroundColor: c.bg, color: c.fg }}
              >
                {m.name.split(' ').map((n) => n[0]).join('')}
              </div>
              <span className="text-xs text-ink-900 font-medium flex-1 truncate">{m.name}</span>
              <span className="text-xs font-semibold tabular-nums" style={{ color: metricColor }}>
                {m.value}
              </span>
            </div>
          );
        })}
      </div>
    </div>
  );
}

function QualityRing({ pct }) {
  const size = 32;
  const stroke = 3;
  const r = (size - stroke) / 2;
  const circ = 2 * Math.PI * r;
  const len = (Math.min(Math.max(pct, 0), 100) / 100) * circ;
  return (
    <span className="relative inline-flex items-center justify-center flex-shrink-0" style={{ width: size, height: size }}>
      <svg width={size} height={size} className="-rotate-90">
        <circle cx={size / 2} cy={size / 2} r={r} fill="none" stroke="#E4E8F0" strokeWidth={stroke} />
        <circle
          cx={size / 2}
          cy={size / 2}
          r={r}
          fill="none"
          stroke="#5A81BC"
          strokeWidth={stroke}
          strokeDasharray={`${len} ${circ}`}
          strokeLinecap="round"
        />
      </svg>
      <span className="absolute text-[9px] font-semibold text-ink-900 tabular-nums">{`${pct}%`}</span>
    </span>
  );
}

const sortFields = {
  'Employee Name': (r) => r.name.toLowerCase(),
  'Work Hours': (r) => toMinutes(r.work),
  'Manual Time': (r) => toMinutes(r.manual),
  Activity: (r) => r.activity,
  'Quality Hours': (r) => toMinutes(r.quality),
  'Bot Alerts': (r) => r.botAlerts,
};

// Returns a safe array with at least two points so the Sparkline never divides by zero.
function safeSpark(arr, fallback) {
  if (Array.isArray(arr) && arr.length > 1) return arr;
  const v = Number(fallback) || 0;
  return [v, v];
}

function SimpleDateRangeButton({ value, onChange }) {
  const [open, setOpen] = useState(false);
  const label = value?.from && value?.to
    ? `${format(value.from, 'MMM dd')} – ${format(value.to, 'MMM dd, yyyy')}`
    : 'Pick a range';
  const presets = [
    { id: 7, label: 'Last 7 days' },
    { id: 14, label: 'Last 14 days' },
    { id: 30, label: 'Last 30 days' },
    { id: 90, label: 'Last 90 days' },
  ];
  return (
    <div className="relative">
      <button
        type="button"
        onClick={() => setOpen((o) => !o)}
        className="w-full inline-flex items-center justify-between gap-2 px-3 py-2 border border-surface-2 rounded-lg text-sm bg-white text-ink-900 hover:bg-surface-page transition"
      >
        <span className="inline-flex items-center gap-2">
          <Calendar size={14} className="text-ink-500" />
          {label}
        </span>
        <ChevronDown size={14} className="text-ink-500" />
      </button>
      {open && (
        <div className="absolute z-50 mt-1 right-0 w-48 rounded-lg border border-surface-2 bg-white shadow-lg overflow-hidden">
          {presets.map((p) => (
            <button
              key={p.id}
              type="button"
              onClick={() => { onChange(lastNDays(p.id)); setOpen(false); }}
              className="block w-full text-left px-3 py-2 text-sm text-ink-900 hover:bg-surface-page"
            >
              {p.label}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}

function CardDashboard({ onViewAlerts }) {
  const { activeWorkspace } = useContext(UserContext);

  const [alertChannels, setAlertChannels] = useState(() => BOT_CHANNELS.map((c) => ({ ...c, items: [] })));
  const [alertIdx, setAlertIdx] = useState(BOT_CHANNELS.map(() => 0));
  const [alertCounts, setAlertCounts] = useState({
    hr: 0, it: 0, infosec: 0, total: 0,
  });
  const [alertTopMembers, setAlertTopMembers] = useState([]);
  const [alertsByMember, setAlertsByMember] = useState({});
  const [members, setMembers] = useState([]);
  const [teamsApi, setTeamsApi] = useState([]);
  const [dailySeries, setDailySeries] = useState([]);
  const [workDays, setWorkDays] = useState(5);
  const [totalSeconds, setTotalSeconds] = useState(0);
  const [activeSeconds, setActiveSeconds] = useState(0);
  const [dateRange, setDateRange] = useState(() => lastNDays(30));
  const [periodPreset, setPeriodPreset] = useState('range');
  const [oppsFilter, setOppsFilter] = useState('all');
  const [memberFilter, setMemberFilter] = useState('all');
  const [membersSearch, setMembersSearch] = useState('');
  const [sortKey, setSortKey] = useState('Activity');
  const [sortDir, setSortDir] = useState('desc');
  const [teamsOpen, setTeamsOpen] = useState(true);
  const [membersOpen, setMembersOpen] = useState(true);

  const stepAlert = (i, dir) => setAlertIdx((prev) => prev.map((v, idx) => {
    const len = alertChannels[i].items.length;
    if (idx !== i || len === 0) return v;
    return (v + dir + len) % len;
  }));

  const toggleSort = (k) => {
    if (sortKey === k) setSortDir((d) => (d === 'asc' ? 'desc' : 'asc'));
    else { setSortKey(k); setSortDir('desc'); }
  };

  const getMembersData = async () => {
    if (!activeWorkspace?.id) return;
    const dates = [dateRange.from, dateRange.to];
    const range = getDatesInRange(dates[0], dates[1]);
    const startOfDay = moment(range[0]).utc().startOf('day').format('YYYY-MM-DD HH:mm:ss');
    const endOfDay = moment(range.at(-1)).utc().endOf('day').format('YYYY-MM-DD HH:mm:ss');
    // Previous window of equal length immediately preceding the current one.
    const compareStart = moment(range[0]).utc().subtract(range.length, 'days').startOf('day')
      .format('YYYY-MM-DD HH:mm:ss');
    setWorkDays(countWeekdaysInRange(startOfDay, endOfDay));

    const response = await sendRequest({
      method: 'get',
      url: API.WORKSPACE.dashboardMembers(activeWorkspace.id),
      params: { startOfDay, endOfDay, compareStart },
    });

    if (!response.success) return;
    const { teams: teamsResp, reportingManagerMembers } = response.data;

    const currentStartMs = moment.utc(startOfDay, 'YYYY-MM-DD HH:mm:ss').valueOf();
    const dayMap = new Map(); // current-period workspace daily totals for sparklines

    // Split a member's dailyActivity into current vs previous period in a single pass.
    const processDaily = (dailyActivity = [], collectSeries = true) => {
      let tot = 0; let act = 0; let prevTot = 0; let prevAct = 0; let activeDays = 0;
      dailyActivity.forEach((a) => {
        if (!a.totalSeconds) return;
        const t = Number(a.totalSeconds) || 0;
        const ac = Number(a.activeSeconds) || 0;
        if (moment.utc(a.date).valueOf() >= currentStartMs) {
          tot += t;
          act += ac;
          if (ac > 0) activeDays += 1;
          if (collectSeries) {
            const key = moment.utc(a.date).format('YYYY-MM-DD');
            const d = dayMap.get(key) || { tot: 0, act: 0 };
            d.tot += t;
            d.act += ac;
            dayMap.set(key, d);
          }
        } else {
          prevTot += t;
          prevAct += ac;
        }
      });
      return { tot, act, prevTot, prevAct, activeDays };
    };

    const sumManual = (entries = []) => entries.reduce((s, e) => s + (Number(e.durationSeconds) || 0), 0);

    const merged = [];
    const ids = new Set();
    const processedMap = new Map();
    const updatedTeams = teamsResp.map((team) => {
      let teamTot = 0;
      let teamAct = 0;
      const mates = team.teamMates.map((tm) => {
        const { userId, dailyActivity } = tm.member;
        if (processedMap.has(userId)) {
          const existing = processedMap.get(userId);
          teamTot += existing.member.totalSecondsElapsed;
          teamAct += existing.member.totalActiveSeconds;
          return existing;
        }
        const {
          tot, act, prevTot, prevAct, activeDays,
        } = processDaily(dailyActivity);
        const manual = sumManual(tm.member.manualTimeEntries);
        const engagementScore = tot > 0 ? Math.round((act * 100) / tot) : 0;
        const updated = {
          ...tm,
          member: {
            ...tm.member,
            totalSecondsElapsed: tot,
            totalActiveSeconds: act,
            totalManualSeconds: manual,
            prevTotalSeconds: prevTot,
            prevActiveSeconds: prevAct,
            activeDays,
            engagementScore,
          },
        };
        teamTot += tot;
        teamAct += act;
        processedMap.set(userId, updated);
        ids.add(userId);
        merged.push(updated);
        return updated;
      });
      const teamScore = teamTot > 0 ? Math.round((teamAct * 100) / teamTot) : 0;
      return {
        ...team,
        totalSecondsElapsed: teamTot,
        totalActiveSeconds: teamAct,
        engagementScore: teamScore,
        teamMates: mates,
      };
    });

    reportingManagerMembers.forEach((m) => {
      if (ids.has(m.userId)) return;
      const {
        tot, act, prevTot, prevAct, activeDays,
      } = processDaily(m.dailyActivity);
      const manual = sumManual(m.manualTimeEntries);
      const engagementScore = tot > 0 ? Math.round((act * 100) / tot) : 0;
      merged.push({
        member: {
          ...m,
          totalSecondsElapsed: tot,
          totalActiveSeconds: act,
          totalManualSeconds: manual,
          prevTotalSeconds: prevTot,
          prevActiveSeconds: prevAct,
          activeDays,
          engagementScore,
        },
      });
    });

    const series = [...dayMap.entries()]
      .sort(([a], [b]) => (a < b ? -1 : 1))
      .map(([date, v]) => ({ date, tot: v.tot, act: v.act }));

    setMembers(merged);
    setTeamsApi(updatedTeams);
    setDailySeries(series);
  };

  const getAlerts = async () => {
    if (!activeWorkspace?.id) return;
    // The cards show this calendar month's pending alerts. Sent as a UTC window
    // because alerts are stamped in UTC.
    const now = new Date();
    const params = {
      start: format(startOfMonth(now), "yyyy-MM-dd'T'00:00:00"),
      end: format(endOfMonth(now), "yyyy-MM-dd'T'23:59:59"),
    };
    const response = await sendRequest({
      method: 'get',
      url: API.WORKSPACE.dashboardAlerts(activeWorkspace.id),
      params,
      timeout: 60000,
    });
    if (!response.success) return;
    const { alerts } = response.data;
    const buckets = { HR: [], IT: [], Infosec: [] };
    const byMember = new Map();
    alerts.forEach((alert) => {
      if (!alert.member?.isTracking) return;
      if (buckets[alert.category]) buckets[alert.category].push(alert);

      const memberId = alert.member.id;
      const name = `${alert.member.user?.firstName || ''} ${alert.member.user?.lastName || ''}`.trim() || 'Unknown';
      const entry = byMember.get(memberId) || {
        memberId,
        name,
        initials: name
          .split(' ')
          .map((n) => n[0])
          .join('')
          .slice(0, 2)
          .toUpperCase(),
        hrCount: 0,
        itCount: 0,
        infosecCount: 0,
      };
      if (alert.category === 'HR') entry.hrCount += 1;
      else if (alert.category === 'IT') entry.itCount += 1;
      else if (alert.category === 'Infosec') entry.infosecCount += 1;
      byMember.set(memberId, entry);
    });

    const counts = {
      hr: buckets.HR.length,
      it: buckets.IT.length,
      infosec: buckets.Infosec.length,
      total: buckets.HR.length + buckets.IT.length + buckets.Infosec.length,
    };
    setAlertCounts(counts);

    const topMembers = [...byMember.values()]
      .map((m) => {
        const total = m.hrCount + m.itCount + m.infosecCount;
        return {
          ...m,
          total,
          hr: total > 0 ? Math.round((m.hrCount * 100) / total) : 0,
          it: total > 0 ? Math.round((m.itCount * 100) / total) : 0,
          infosec: total > 0 ? Math.round((m.infosecCount * 100) / total) : 0,
        };
      })
      .sort((a, b) => b.total - a.total)
      .slice(0, 5);
    setAlertTopMembers(topMembers);

    const perMember = {};
    byMember.forEach((v, k) => {
      perMember[k] = v.hrCount + v.itCount + v.infosecCount;
    });
    setAlertsByMember(perMember);

    const managerName = (member) => {
      const u = member?.Manager?.user || member?.manager?.user;
      if (!u) return 'Unassigned';
      return `${u.firstName || ''} ${u.lastName || ''}`.trim() || 'Unassigned';
    };

    const next = BOT_CHANNELS.map((ch) => {
      // Every alert for the month, newest first. The card shows one at a time,
      // so the length is the counter's denominator rather than a DOM cost.
      const items = buckets[ch.apiKey].map((a) => ({
        id: a.id,
        user: `${a.member.user?.firstName || ''} ${a.member.user?.lastName || ''}`.trim() || 'Unknown',
        msg: a.message || a.alertType?.triggerCondition || a.alertMessageInternal || 'Alert triggered',
        team: a.member.team?.name || a.team || '—',
        manager: managerName(a.member),
        severity: a.severity || 'medium',
      }));
      return { ...ch, items };
    });
    setAlertChannels(next);
    setAlertIdx(next.map(() => 0));
  };

  useEffect(() => {
    getMembersData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dateRange, activeWorkspace?.id]);

  useEffect(() => {
    getAlerts();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activeWorkspace?.id]);

  useEffect(() => {
    const tot = members.reduce((s, m) => s + Number(m.member.totalSecondsElapsed || 0), 0);
    const act = members.reduce((s, m) => s + Number(m.member.totalActiveSeconds || 0), 0);
    setTotalSeconds(tot);
    setActiveSeconds(act);
  }, [members]);

  const totalHours = (totalSeconds / 3600).toFixed(1);
  const qualityHours = (activeSeconds / 3600).toFixed(1);
  const engagementScoreNum = totalSeconds > 0 ? Math.round((activeSeconds * 100) / totalSeconds) : 0;

  // Previous-period workspace totals for KPI deltas.
  const prevTotals = useMemo(() => members.reduce((a, m) => ({
    tot: a.tot + Number(m.member.prevTotalSeconds || 0),
    act: a.act + Number(m.member.prevActiveSeconds || 0),
  }), { tot: 0, act: 0 }), [members]);

  const pctDelta = (cur, prev) => {
    if (prev > 0) return ((cur - prev) / prev) * 100;
    return cur > 0 ? 100 : 0;
  };
  const totalHoursDelta = pctDelta(totalSeconds, prevTotals.tot);
  const qualityHoursDelta = pctDelta(activeSeconds, prevTotals.act);
  const prevEngagement = prevTotals.tot > 0 ? (prevTotals.act * 100) / prevTotals.tot : 0;
  const engagementDelta = engagementScoreNum - prevEngagement; // percentage points

  const sparks = useMemo(() => {
    const s = dailySeries.slice(-14);
    return {
      total: s.map((d) => Number((d.tot / 3600).toFixed(2))),
      quality: s.map((d) => Number((d.act / 3600).toFixed(2))),
      engagement: s.map((d) => (d.tot > 0 ? Math.round((d.act * 100) / d.tot) : 0)),
    };
  }, [dailySeries]);

  const fmtDelta = (d) => `${d >= 0 ? '+' : ''}${d.toFixed(1)}%`;

  const criticalAlertColors = {
    hr: '#213D69',
    it: '#5A81BC',
    infosec: '#B5BAC4',
  };

  const criticalAlertLegendData = useMemo(() => {
    const rows = [
      { id: 'hr', label: 'HR Bot Alerts', count: alertCounts.hr },
      { id: 'it', label: 'IT Bot Alerts', count: alertCounts.it },
      { id: 'infosec', label: 'Infosec Bot Alerts', count: alertCounts.infosec },
    ];
    const { total } = alertCounts;
    return rows.map((r) => ({
      ...r,
      color: criticalAlertColors[r.id] || '#B5BAC4',
      pct: total > 0 ? Math.round((r.count * 1000) / total) / 10 : 0,
    }));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [alertCounts]);

  const criticalAlertTotal = alertCounts.total;

  const alertTopMembersData = alertTopMembers;

  const memberName = (m) => m?.member?.user?.fullName
    || `${m?.member?.user?.firstName || ''} ${m?.member?.user?.lastName || ''}`.trim()
    || 'Member';

  // Real engagement distribution derived from member engagement scores.
  const engagementSegmentsData = useMemo(() => {
    const scored = members.filter((m) => (m.member?.engagementScore || 0) > 0);
    const n = scored.length;
    const inBucket = (lo, hi) => scored.filter((m) => {
      const s = m.member.engagementScore;
      return s >= lo && s <= hi;
    }).length;
    const pct = (x) => (n > 0 ? Math.round((x * 100) / n) : 0);
    return [
      { label: 'Deep Focus', range: '51–100%', color: 'bg-shoot-success', pct: pct(inBucket(51, 100)) },
      { label: 'Focused', range: '21–50%', color: 'bg-[#F19235]', pct: pct(inBucket(21, 50)) },
      { label: 'Low Activity', range: '1–20%', color: 'bg-[#cfd4dc]', pct: pct(inBucket(1, 20)) },
    ];
  }, [members]);

  // Daily quality-time stats derived from per-member active days.
  const qualityStats = useMemo(() => {
    const totalActiveDays = members.reduce((s, m) => s + (m.member?.activeDays || 0), 0);
    const totalActive = members.reduce((s, m) => s + Number(m.member?.totalActiveSeconds || 0), 0);
    const memberCount = members.length;
    const sessions = memberCount > 0 ? totalActiveDays / memberCount : 0;
    const avgLengthHours = totalActiveDays > 0 ? totalActive / totalActiveDays / 3600 : 0;
    return { sessions: sessions.toFixed(1), avgLength: avgLengthHours.toFixed(2) };
  }, [members]);

  const lowWorkTimeData = useMemo(() => members
    .filter((m) => workDays > 0 && (m.member?.totalSecondsElapsed || 0) / workDays < 28800)
    .sort((a, b) => (a.member.totalSecondsElapsed || 0) - (b.member.totalSecondsElapsed || 0))
    .slice(0, 8)
    .map((m) => ({
      name: memberName(m),
      value: `${convertSecToTimeFormat(Math.ceil((m.member.totalSecondsElapsed || 0) / workDays), 'HH:MM')} hr/day`,
    })), [members, workDays]);

  const lowActivityData = useMemo(() => members
    .filter((m) => (m.member?.engagementScore || 0) > 0 && (m.member?.engagementScore || 0) < 35)
    .sort((a, b) => (a.member.engagementScore || 0) - (b.member.engagementScore || 0))
    .slice(0, 8)
    .map((m) => ({
      name: memberName(m),
      value: `${m.member.engagementScore || 0}%`,
    })), [members]);

  const opportunitiesRows = useMemo(() => members.map((m) => {
    const memberId = m.member?.id;
    const work = m.member?.totalSecondsElapsed || 0;
    const manual = m.member?.totalManualSeconds || 0;
    const quality = m.member?.totalActiveSeconds || 0;
    const prevTot = m.member?.prevTotalSeconds || 0;
    const prevAct = m.member?.prevActiveSeconds || 0;
    const prevEng = prevTot > 0 ? Math.round((prevAct * 100) / prevTot) : 0;
    const curEng = m.member?.engagementScore || 0;
    const qualityDelta = prevAct > 0
      ? Math.round(((quality - prevAct) / prevAct) * 100)
      : (quality > 0 ? 100 : 0);
    return {
      name: memberName(m),
      work: convertSecToTimeFormat(work),
      manual: convertSecToTimeFormat(manual),
      activity: curEng,
      activityDelta: curEng - prevEng,
      quality: convertSecToTimeFormat(quality),
      qualityDelta,
      botAlerts: alertsByMember?.[memberId] || 0,
      createdAt: m.member?.createdAt,
    };
  }), [members, alertsByMember]);

  const highSpikesData = useMemo(() => members
    .filter((m) => (m.member?.engagementScore || 0) > 90)
    .sort((a, b) => (b.member.engagementScore || 0) - (a.member.engagementScore || 0))
    .slice(0, 8)
    .map((m) => ({
      name: memberName(m),
      value: `${m.member.engagementScore || 0}%`,
    })), [members]);

  const kpis = [
    {
      label: 'Total Hours', value: totalHours, delta: fmtDelta(totalHoursDelta), up: totalHoursDelta >= 0, spark: safeSpark(sparks.total, totalHours), accent: '#3d5a8a',
    },
    {
      label: 'Quality Hours', value: qualityHours, delta: fmtDelta(qualityHoursDelta), up: qualityHoursDelta >= 0, spark: safeSpark(sparks.quality, qualityHours), accent: '#6b9f5f',
    },
    {
      label: 'Engagement Score', value: `${engagementScoreNum}%`, delta: fmtDelta(engagementDelta), up: engagementDelta >= 0, spark: safeSpark(sparks.engagement, engagementScoreNum), accent: '#F19235',
    },
  ];

  const teamsList = useMemo(() => teamsApi.map((t) => ({ name: t.name, score: t.engagementScore })), [teamsApi]);
  const membersList = useMemo(() => members.map((m) => ({
    name: m.member.user?.fullName || `${m.member.user?.firstName || ''} ${m.member.user?.lastName || ''}`.trim() || 'Member',
    role: m.member.role?.name || m.member.user?.title || 'Member',
    score: m.member.engagementScore,
  })), [members]);

  const filteredOpps = useMemo(() => {
    let rows = opportunitiesRows;
    if (memberFilter !== 'all') rows = rows.filter((r) => r.name === memberFilter);
    if (oppsFilter === 'low') rows = rows.filter((r) => r.activity > 0 && r.activity < 35);
    else if (oppsFilter === 'recent') {
      rows = rows.filter((r) => r.createdAt && moment().diff(moment(r.createdAt), 'days') <= 90);
    }
    return rows;
  }, [opportunitiesRows, oppsFilter, memberFilter]);

  const sortedOpps = useMemo(() => [...filteredOpps].sort((a, b) => {
    const av = sortFields[sortKey](a);
    const bv = sortFields[sortKey](b);
    const cmp = av < bv ? -1 : av > bv ? 1 : 0;
    return sortDir === 'asc' ? cmp : -cmp;
  }), [filteredOpps, sortKey, sortDir]);

  const dateLabel = dateRange?.from && dateRange?.to
    ? `${format(dateRange.from, 'EEE, MMM dd')} – ${format(dateRange.to, 'MMM dd, yyyy')}`
    : '';

  const handlePeriodChange = (e) => {
    const v = e.target.value;
    setPeriodPreset(v);
    if (v === 'Today') setDateRange(lastNDays(1));
    else if (v === 'This Week') setDateRange({ from: moment().startOf('week').toDate(), to: new Date() });
    else if (v === 'This Month') setDateRange({ from: moment().startOf('month').toDate(), to: new Date() });
  };

  const filteredMembers = membersList.filter((m) => m.name.toLowerCase().includes(membersSearch.toLowerCase()));

  const filtersBlock = (
    <div className={`rounded-xl bg-white border border-surface-2 ${softShadow} p-4`}>
      <div className="flex items-center gap-2 mb-3">
        <Users size={14} className="text-brand-500" />
        <h3 className="text-sm font-semibold text-ink-900">Filters</h3>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-3 lg:grid-cols-1 gap-2">
        <SimpleDateRangeButton
          value={dateRange}
          onChange={(r) => { setPeriodPreset('range'); setDateRange(r); }}
        />
        <select
          value={periodPreset}
          onChange={handlePeriodChange}
          className="w-full px-3 py-2 border border-surface-2 rounded-lg text-sm bg-white text-ink-900"
        >
          <option value="range">Custom Range</option>
          <option value="Today">Today</option>
          <option value="This Week">This Week</option>
          <option value="This Month">This Month</option>
        </select>
        <select
          value={memberFilter}
          onChange={(e) => setMemberFilter(e.target.value)}
          className="w-full px-3 py-2 border border-surface-2 rounded-lg text-sm bg-white text-ink-900"
        >
          <option value="all">All Members</option>
          {membersList.map((m) => (
            <option key={m.name} value={m.name}>{m.name}</option>
          ))}
        </select>
      </div>
    </div>
  );

  return (
    <div className="shoot-insights-page space-y-5">
      {/* Full-width bot alert cards */}
      <motion.div
        initial={{ opacity: 0, y: 8 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.3 }}
        className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3"
      >
        {alertChannels.map((ch, ci) => {
          const hasItems = ch.items.length > 0;
          const item = hasItems ? (ch.items[alertIdx[ci]] || ch.items[0]) : null;
          const initials = item ? item.user.split(' ').map((n) => n[0]).join('') : '';
          return (
            <div
              key={ch.id}
              className="group relative flex flex-col overflow-hidden rounded-xl p-4 border-[1px] border-solid shadow-sm transition-all hover:shadow-lg hover:ring-1 hover:ring-inset"
              style={{
                backgroundColor: `${ch.userColor}14`,
                borderColor: `${ch.userColor}55`,
                '--tw-ring-color': `${ch.userColor}55`,
              }}
            >
              <div className="mb-3 flex items-center justify-between">
                <div className="flex items-center gap-2">
                  <span
                    className="flex h-7 w-7 items-center justify-center rounded-full"
                    style={{
                      backgroundColor: `color-mix(in oklab, ${ch.userColor} 18%, white)`,
                      color: ch.userColor,
                    }}
                  >
                    <Bell className="h-3.5 w-3.5" />
                  </span>
                  <span className="text-[11px] font-semibold uppercase tracking-wider text-ink-500">{ch.label}</span>
                </div>
                <div className="flex items-center gap-1">
                  <button
                    type="button"
                    aria-label={`Previous ${ch.label} alert`}
                    onClick={() => stepAlert(ci, -1)}
                    disabled={!hasItems}
                    className="flex h-7 w-7 items-center justify-center rounded-full text-ink-500 transition hover:bg-surface-1 hover:text-ink-900 disabled:opacity-40 disabled:cursor-not-allowed"
                  >
                    <ChevronLeft className="h-4 w-4" />
                  </button>
                  <span className="min-w-[34px] text-center text-xs font-medium tabular-nums text-ink-500">
                    {hasItems ? `${alertIdx[ci] + 1}/${ch.items.length}` : '0/0'}
                  </span>
                  <button
                    type="button"
                    aria-label={`Next ${ch.label} alert`}
                    onClick={() => stepAlert(ci, 1)}
                    disabled={!hasItems}
                    className="flex h-7 w-7 items-center justify-center rounded-full text-ink-500 transition hover:bg-surface-1 hover:text-ink-900 disabled:opacity-40 disabled:cursor-not-allowed"
                  >
                    <ChevronRight className="h-4 w-4" />
                  </button>
                </div>
              </div>
              {hasItems ? (
                <>
                  <motion.div
                    key={`${ch.id}-${alertIdx[ci]}`}
                    initial={{ opacity: 0, y: 4 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.25 }}
                  >
                    <div className="mb-2 flex items-center gap-2">
                      <div
                        className="flex h-7 w-7 items-center justify-center rounded-full text-[10px] font-semibold text-white shadow-sm"
                        style={{
                          backgroundImage: `linear-gradient(to bottom right, ${ch.userColor}, ${ch.accentEnd})`,
                        }}
                      >
                        {initials}
                      </div>
                      <span className="truncate text-sm font-semibold text-ink-900">{item.user}</span>
                    </div>
                    <p className="mb-3 text-sm leading-snug text-ink-900/80">{item.msg}</p>
                  </motion.div>
                  <div className="mt-auto flex items-center gap-4 border-t border-rule/70 pt-3 text-xs">
                    <div className="flex items-center gap-1.5">
                      <Users className="h-3.5 w-3.5 text-ink-500" />
                      <span className="text-ink-500">Team</span>
                      <span className="font-medium text-ink-900">{item.team}</span>
                    </div>
                    <div className="h-3 w-px bg-rule" />
                    <div className="flex items-center gap-1.5">
                      <UserCog className="h-3.5 w-3.5 text-ink-500" />
                      <span className="text-ink-500">Mgr</span>
                      <span className="font-medium text-ink-900">{item.manager}</span>
                    </div>
                  </div>
                </>
              ) : (
                <div className="flex flex-1 flex-col items-center justify-center py-6 text-center">
                  <CheckCircle className="mb-2 h-6 w-6 text-ink-500/40" />
                  <p className="text-xs text-ink-500">No active alerts</p>
                </div>
              )}
            </div>
          );
        })}
      </motion.div>

      {/* Mobile-only: filters above main content */}
      <div className="lg:hidden">{filtersBlock}</div>

      <div className="flex flex-col lg:flex-row gap-5 lg:gap-6">
        <div className="flex-1 space-y-5 min-w-0">
          {/* KPI tiles */}
          <motion.div
            initial={{ opacity: 0, y: 8 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.3, delay: 0.05 }}
            className="grid grid-cols-1 sm:grid-cols-3 gap-3"
          >
            {kpis.map((k) => (
              <div key={k.label} className={`rounded-xl bg-white border border-surface-2 ${softShadow} p-4`}>
                <div className="flex items-center justify-between mb-2">
                  <span className="text-xs font-semibold text-ink-500 uppercase tracking-wide">{k.label}</span>
                  <span className="inline-flex items-center gap-0.5 text-xs font-medium" style={{ color: k.up ? '#6b9f5f' : '#b94f3c' }}>
                    {k.up ? <ArrowUpRight size={12} /> : <ArrowDownRight size={12} />}
                    {' '}
                    {k.delta}
                  </span>
                </div>
                <div className="flex items-end justify-between">
                  <span className="text-2xl font-bold text-ink-900 leading-none">{k.value}</span>
                  <Sparkline points={k.spark} color={k.accent} />
                </div>
              </div>
            ))}
          </motion.div>

          {/* Performance Reports */}
          <motion.div
            initial={{ opacity: 0, y: 8 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.3, delay: 0.1 }}
          >
            <h3 className="text-base font-semibold text-ink-900 mb-3">Performance Reports</h3>
            <div className="grid grid-cols-1 lg:grid-cols-5 gap-3">
              <div className={`lg:col-span-3 rounded-xl bg-white border border-surface-2 ${softShadow} p-5`}>
                <div className="flex items-center justify-between mb-4">
                  <div className="flex items-center gap-1.5">
                    <h4 className="text-xs font-semibold text-ink-500 uppercase tracking-wide">Overall Engagement Score</h4>
                    <InfoTooltip text="Weighted score across Deep Focus, Focused, and Low Activity segments for the selected date range." />
                  </div>
                  <span className="text-xs text-ink-500">{dateLabel.replace(/ \d{4}$/, '')}</span>
                </div>
                <div className="flex items-center gap-6">
                  <RadialGauge value={engagementScoreNum} color="#5A81BC" />
                  <div className="flex-1 space-y-3">
                    <StackedBar
                      segments={engagementSegmentsData.map((s) => ({
                        pct: s.pct,
                        color: s.color.includes('shoot-success')
                          ? '#6b9f5f'
                          : s.color.includes('F19235')
                            ? '#F19235'
                            : '#cfd4dc',
                      }))}
                    />
                    <div className="space-y-1.5">
                      {engagementSegmentsData.map((s) => (
                        <div key={s.label} className="flex items-center gap-2 text-xs">
                          <span className={`w-2 h-2 rounded-sm ${s.color}`} />
                          <span className="text-ink-900 font-medium">{s.label}</span>
                          <span className="text-ink-500">{s.range}</span>
                          <span className="ml-auto text-ink-900 font-semibold">{`${s.pct}%`}</span>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              </div>

              <div className={`lg:col-span-2 rounded-xl bg-white border border-surface-2 ${softShadow} p-5`}>
                <div className="flex items-center gap-1.5 mb-4">
                  <h4 className="text-xs font-semibold text-ink-500 uppercase tracking-wide">Daily Quality Time Stats</h4>
                  <InfoTooltip text="Average productive working time, number of quality sessions, and average session length per day." />
                </div>
                <div className="flex items-center gap-4">
                  <RadialGauge value={engagementScoreNum} color="#5A81BC" label="Quality" />
                  <div className="flex-1 space-y-2">
                    {[
                      {
                        label: 'Quality hours', value: workDays > 0 ? (activeSeconds / workDays / 3600).toFixed(2) : '0.00', icon: Clock, bg: 'bg-[#e8eef7]', fg: 'text-brand-500',
                      },
                      {
                        label: 'Quality sessions', value: qualityStats.sessions, icon: CheckCircle, bg: 'bg-[#eef5ea]', fg: 'text-shoot-success',
                      },
                      {
                        label: 'Avg. session length', value: qualityStats.avgLength, icon: TrendingUp, bg: 'bg-[#fde6d2]', fg: 'text-[#F19235]',
                      },
                    ].map((s) => {
                      const Icon = s.icon;
                      return (
                        <div key={s.label} className="flex items-center gap-2 p-2 rounded-lg bg-surface-page border border-surface-1">
                          <div className={`w-7 h-7 rounded-md ${s.bg} flex items-center justify-center`}>
                            <Icon size={12} className={s.fg} />
                          </div>
                          <div className="flex-1 min-w-0">
                            <p className="text-[11px] text-ink-500">{s.label}</p>
                            <p className="text-sm font-bold text-ink-900 leading-tight">{s.value}</p>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                </div>
              </div>
            </div>
          </motion.div>

          {/* Critical Alerts + Top Members */}
          <motion.div
            initial={{ opacity: 0, y: 8 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.3, delay: 0.15 }}
            className={`rounded-xl bg-white border border-surface-2 ${softShadow} overflow-hidden`}
          >
            <div className="flex items-center justify-between px-5 pt-5 pb-4">
              <div className="flex items-center gap-1.5">
                <h3 className="text-xs font-semibold text-ink-500 uppercase tracking-wide">Critical Alerts</h3>
                <InfoTooltip
                  text="Distribution of HR, IT, and Infosec bot alerts across all members for the selected date range."
                  placement="bottom"
                />
              </div>
              <button type="button" onClick={onViewAlerts} className="text-xs text-brand-500 font-medium hover:underline">View All</button>
            </div>
            <div className="grid grid-cols-1 lg:grid-cols-12 gap-0">
              <div className="lg:col-span-4 px-5 pb-5 flex flex-col items-center justify-center border-b lg:border-b-0 lg:border-r border-surface-1">
                <div className="relative w-32 h-32">
                  <svg viewBox="0 0 120 120" className="w-full h-full -rotate-90">
                    <circle cx="60" cy="60" r="48" fill="none" strokeWidth="8" className="stroke-surface-1" />
                    {(() => {
                      const circ = 2 * Math.PI * 48;
                      let offset = 0;
                      return criticalAlertLegendData
                        .filter((l) => l.pct > 0)
                        .map((l, i) => {
                          const len = (l.pct / 100) * circ;
                          const el = (
                            <motion.circle
                              key={i}
                              cx="60"
                              cy="60"
                              r="48"
                              fill="none"
                              strokeWidth="8"
                              stroke={l.color}
                              strokeDasharray={`${len} ${circ}`}
                              strokeDashoffset={-offset}
                              strokeLinecap="butt"
                              initial={{ strokeDasharray: `0 ${circ}` }}
                              animate={{ strokeDasharray: `${len} ${circ}` }}
                              transition={{ duration: 0.9, ease: 'easeOut' }}
                            />
                          );
                          offset += len;
                          return el;
                        });
                    })()}
                  </svg>
                  <div className="absolute inset-0 flex flex-col items-center justify-center px-4">
                    <span
                      className="font-bold text-[#cc4525] leading-none tabular-nums text-center break-all"
                      style={(() => {
                        const len = String(criticalAlertTotal).length;
                        // Shrink as digits grow so the number always fits inside the 128px donut.
                        const size = len <= 2 ? 36 : len <= 3 ? 32 : len <= 4 ? 26 : len <= 5 ? 22 : 18;
                        return { fontSize: `${size}px` };
                      })()}
                    >
                      {criticalAlertTotal}
                    </span>
                    <span className="text-[10px] text-ink-500 uppercase tracking-wider mt-1.5">Total Alerts</span>
                  </div>
                </div>
                <div className="mt-5 w-full space-y-2">
                  {criticalAlertLegendData.map((l) => (
                    <div key={l.label} className="flex items-center gap-2 text-xs">
                      <span className="w-2.5 h-2.5 rounded-full flex-shrink-0" style={{ backgroundColor: l.color }} />
                      <span className="text-ink-500 flex-1 truncate">{l.label}</span>
                      <span className="font-semibold text-ink-900 tabular-nums">{`${l.pct}%`}</span>
                    </div>
                  ))}
                </div>
              </div>
              <div className="lg:col-span-8 px-5 pb-5 pt-4 lg:pt-0">
                <div className="flex items-center justify-between mb-3">
                  <p className="text-[11px] text-ink-500 uppercase tracking-wider font-semibold">Top Members — Alert Distribution</p>
                  <div className="flex items-center gap-3 text-[10px] text-ink-500">
                    {criticalAlertLegendData.map((l) => (
                      <span key={l.label} className="inline-flex items-center gap-1">
                        <span className="w-1.5 h-1.5 rounded-full" style={{ backgroundColor: l.color }} />
                        {l.label.replace(' Bot Alerts', '')}
                      </span>
                    ))}
                  </div>
                </div>
                <div className="space-y-3">
                  {alertTopMembersData.length === 0 && (
                    <div className="text-xs text-ink-500 py-4 text-center">No alerts in this period</div>
                  )}
                  {alertTopMembersData.map((m) => {
                    const total = m.hr + m.it + m.infosec;
                    return (
                      <div key={m.name} className="grid grid-cols-12 items-center gap-3">
                        <div className="col-span-4 flex items-center gap-2.5 min-w-0">
                          <div className="w-7 h-7 rounded-full bg-[#e8eef7] flex items-center justify-center text-[10px] font-semibold text-brand-500 flex-shrink-0">
                            {m.initials}
                          </div>
                          <span className="text-xs text-ink-900 font-medium truncate">{m.name}</span>
                        </div>
                        <div className="col-span-7">
                          <StackedBar
                            segments={[
                              { pct: m.hr, color: '#213D69' },
                              { pct: m.it, color: '#5A81BC' },
                              { pct: m.infosec, color: '#B5BAC4' },
                            ]}
                          />
                        </div>
                        <div className="col-span-1 text-right">
                          <span className="text-xs font-semibold text-ink-900 tabular-nums">{`${total}%`}</span>
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>
            </div>
          </motion.div>

          {/* Major Shifts in Engagement */}
          <motion.div
            initial={{ opacity: 0, y: 8 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.3, delay: 0.2 }}
          >
            <div className="mb-3">
              <h3 className="text-base font-semibold text-ink-900">Major Shifts in Engagement</h3>
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3">
              <ShiftCard title="Low Work Time Alerts" reason="Work time below 08:00 hr/day" timeline="This Week" items={lowWorkTimeData} metricColor="#b94f3c" />
              <ShiftCard title="Members with Low Activity" reason="Weekly activity rate under 35%" timeline="This Week" items={lowActivityData} metricColor="#b94f3c" />
              <ShiftCard title="High Activity Spikes" reason="Weekly activity rate above 90%" timeline="This Week" items={highSpikesData} metricColor="#53A551" />
            </div>
          </motion.div>

          {/* Engagement Opportunities Table */}
          <motion.div
            initial={{ opacity: 0, y: 8 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.3, delay: 0.25 }}
            className={`rounded-xl bg-white border border-surface-2 ${softShadow} overflow-hidden`}
          >
            <div className="p-5 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3 border-b border-surface-1">
              <h3 className="text-base font-semibold text-ink-900">Engagement Opportunities</h3>
              <div className="flex items-center gap-1.5 flex-wrap">
                {[
                  { id: 'all', label: 'All Members' },
                  { id: 'recent', label: 'Joined within Last 90 Days' },
                  { id: 'low', label: 'Low Engagement' },
                ].map((f) => (
                  <button
                    key={f.id}
                    type="button"
                    onClick={() => setOppsFilter(f.id)}
                    className={`px-3 py-1.5 rounded-full text-xs font-medium transition ${oppsFilter === f.id ? 'bg-brand-500 text-white' : 'bg-white border border-surface-2 text-ink-500 hover:bg-gray-50'}`}
                  >
                    {f.label}
                  </button>
                ))}
              </div>
            </div>
            <div className="overflow-auto max-h-[564px]">
              <table className="w-full min-w-[640px]">
                <thead className="bg-surface-page border-b border-surface-1 sticky top-0 z-10">
                  <tr className="text-left text-[11px] text-ink-500 uppercase tracking-wider">
                    {Object.keys(sortFields).map((h) => {
                      const active = sortKey === h;
                      return (
                        <th key={h} className="px-5 py-3 font-semibold">
                          <button
                            type="button"
                            onClick={() => toggleSort(h)}
                            className={`inline-flex items-center gap-1 text-[11px] uppercase tracking-wider font-semibold transition ${active ? 'text-ink-900' : 'hover:text-ink-900'}`}
                          >
                            {h}
                            {active
                              ? (sortDir === 'asc' ? <ChevronUp size={12} /> : <ChevronDown size={12} />)
                              : <ChevronsUpDown size={12} className="text-ink-500" />}
                          </button>
                        </th>
                      );
                    })}
                  </tr>
                </thead>
                <tbody className="divide-y divide-surface-1">
                  {sortedOpps.length === 0 && (
                    <tr>
                      <td colSpan={Object.keys(sortFields).length} className="px-5 py-8 text-center text-xs text-ink-500">
                        There are no engagement opportunities at this moment
                      </td>
                    </tr>
                  )}
                  {sortedOpps.map((r) => (
                    <tr key={r.name} className="text-sm hover:bg-surface-page transition">
                      <td className="px-5 py-3">
                        <div className="flex items-center gap-2.5">
                          <div className="w-7 h-7 rounded-full bg-[#e8eef7] text-brand-500 flex items-center justify-center text-[10px] font-semibold">
                            {r.name.split(' ').map((n) => n[0]).join('')}
                          </div>
                          <span className="font-medium text-ink-900 text-[12px]">{r.name}</span>
                        </div>
                      </td>
                      <td className="px-5 py-3 font-mono text-xs text-ink-900">{r.work}</td>
                      <td className="px-5 py-3 font-mono text-xs text-ink-900">{r.manual}</td>
                      <td className="px-5 py-3">
                        <div className="flex items-center gap-2">
                          <ActivityPill value={r.activity} />
                          <span
                            className="inline-flex items-center gap-0.5 text-[11px] font-medium"
                            style={{ color: r.activityDelta >= 0 ? '#6b9f5f' : '#b94f3c' }}
                          >
                            {r.activityDelta >= 0 ? <ArrowUpRight size={10} /> : <ArrowDownRight size={10} />}
                            {` ${Math.abs(r.activityDelta)}%`}
                          </span>
                        </div>
                      </td>
                      <td className="px-5 py-3">
                        <div className="flex items-center gap-2">
                          <span className="font-mono text-xs text-ink-900">{r.quality}</span>
                          <QualityRing pct={qualityPct(r)} />
                          <span
                            className="inline-flex items-center gap-0.5 text-[11px] font-medium"
                            style={{ color: r.qualityDelta >= 0 ? '#6b9f5f' : '#b94f3c' }}
                          >
                            {r.qualityDelta >= 0 ? <ArrowUpRight size={10} /> : <ArrowDownRight size={10} />}
                            {` ${Math.abs(r.qualityDelta)}%`}
                          </span>
                        </div>
                      </td>
                      <td className="px-5 py-3 text-ink-900 font-semibold text-[12px]">{r.botAlerts}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </motion.div>
        </div>

        {/* Right rail */}
        <motion.aside
          initial={{ opacity: 0, x: 8 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.3, delay: 0.1 }}
          className="w-full lg:w-72 lg:flex-shrink-0 space-y-4"
        >
          {/* Desktop-only: filters in rail */}
          <div className="hidden lg:block">{filtersBlock}</div>

          <div className={`rounded-xl bg-white border border-surface-2 ${softShadow} overflow-hidden`}>
            <button
              type="button"
              onClick={() => setTeamsOpen((o) => !o)}
              className={`w-full flex items-center justify-between px-4 py-3 ${teamsOpen ? 'border-b border-surface-1' : ''} hover:bg-surface-page transition`}
            >
              <span className="text-sm font-semibold text-ink-900">{`Teams (${teamsList.length})`}</span>
              <ChevronDown size={14} className={`text-ink-500 transition-transform ${teamsOpen ? '' : '-rotate-90'}`} />
            </button>
            <div className={`max-h-64 overflow-y-auto ${teamsOpen ? '' : 'hidden'}`}>
              {teamsList.map((t) => (
                <div
                  key={t.name}
                  className="flex items-center justify-between px-4 py-2.5 hover:bg-surface-page cursor-pointer text-xs border-b border-surface-1 last:border-b-0"
                >
                  <span className="text-ink-900 font-medium truncate">{t.name}</span>
                  <span
                    className={`font-semibold ${t.score == null ? 'text-[#a8afbc]' : t.score >= 60 ? 'text-shoot-success' : t.score >= 40 ? 'text-[#F19235]' : 'text-[#b94f3c]'}`}
                  >
                    {t.score == null ? '—' : `${t.score}%`}
                  </span>
                </div>
              ))}
              {teamsList.length === 0 && (
                <div className="px-4 py-6 text-center text-xs text-ink-500">No teams</div>
              )}
            </div>
          </div>

          <div className={`rounded-xl bg-white border border-surface-2 ${softShadow} overflow-hidden`}>
            <button
              type="button"
              onClick={() => setMembersOpen((o) => !o)}
              className={`w-full px-4 py-3 ${membersOpen ? 'border-b border-surface-1' : ''} flex items-center justify-between hover:bg-surface-page transition`}
            >
              <span className="text-sm font-semibold text-ink-900">{`Members (${membersList.length})`}</span>
              <ChevronDown size={14} className={`text-ink-500 transition-transform ${membersOpen ? '' : '-rotate-90'}`} />
            </button>
            <div className={`p-3 border-b border-surface-1 ${membersOpen ? '' : 'hidden'}`}>
              <div className="relative">
                <Search size={12} className="absolute left-2.5 top-1/2 -translate-y-1/2 text-[#a8afbc]" />
                <input
                  value={membersSearch}
                  onChange={(e) => setMembersSearch(e.target.value)}
                  placeholder="Search members"
                  className="w-full pl-7 pr-2 py-1.5 border border-surface-2 rounded-lg text-xs bg-white text-ink-900 focus:outline-none focus:ring-2 focus:ring-brand-500/20"
                />
              </div>
            </div>
            <div className={`max-h-64 overflow-y-auto ${membersOpen ? '' : 'hidden'}`}>
              {filteredMembers.map((m) => (
                <div
                  key={m.name}
                  className="flex items-center gap-2.5 px-4 py-2 hover:bg-surface-page cursor-pointer border-b border-surface-1 last:border-b-0"
                >
                  <div className="w-7 h-7 rounded-full bg-[#e8eef7] text-brand-500 flex items-center justify-center text-[10px] font-semibold flex-shrink-0">
                    {m.name.split(' ').map((n) => n[0]).join('')}
                  </div>
                  <div className="flex-1 min-w-0">
                    <p className="text-xs font-medium text-ink-900 truncate">{m.name}</p>
                    <p className="text-[10px] text-ink-500 truncate">{m.role}</p>
                  </div>
                  <span
                    className={`text-xs font-semibold ${m.score == null ? 'text-[#a8afbc]' : m.score >= 60 ? 'text-shoot-success' : m.score >= 40 ? 'text-[#F19235]' : 'text-[#b94f3c]'}`}
                  >
                    {m.score == null ? '—' : `${m.score}%`}
                  </span>
                </div>
              ))}
              {filteredMembers.length === 0 && (
                <div className="px-4 py-6 text-center text-xs text-ink-500">No members</div>
              )}
            </div>
          </div>
        </motion.aside>
      </div>
    </div>
  );
}

export default CardDashboard;
